import script from "./DesktopSelectChatWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopSelectChatWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopSelectChatWrapper.vue?vue&type=style&index=0&id=a213b4be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a213b4be"]])

export default __exports__